/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ApartmentOutlined, PointOfSaleOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import Tarjeta_Producto from "../Tarjetas/Tarjeta_Producto";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Pedido from "./Formulario_Producto_Pedido";

const Formulario_Pedido_Productos = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'productos',
        Formulario: Formulario_Producto_Pedido,
        nombre: 'Actualizar',
        Tarjeta: Tarjeta_Producto
    })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid2 container size={6}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Ciudad'}
                                  dato={'ciudad'} {...props} editable={false}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Pedido'}
                                   dato={'valor'} {...props}
                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                    <IngresarObjeto/>
                </Grid2>

                <Grid2 container size={12} sx={{mt: 4}}>
                    <IngresoTexto lineas={4} nombre={'Notas Internas'}
                                  dato={'notas'} {...props}
                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Pedido_Productos